import { Badge } from "@/components/ui/badge";

interface TransactionAmountProps {
  transaction: any;
}

export const TransactionAmount = ({ transaction }: TransactionAmountProps) => {
  const getDisplayAmount = () => {
    // Si c'est une vente avec promotion, utiliser le prix total divisé par la quantité
    if (transaction.promotion_id) {
      return transaction.total_amount / transaction.quantity;
    }
    // Pour les ventes à crédit, utiliser le montant payé
    if (transaction.is_fully_paid === false) {
      return transaction.paid_amount || 0;
    }
    // Sinon utiliser le prix unitaire normal
    return transaction.unit_price;
  };

  const amount = getDisplayAmount();
  const isNegative = ["loss", "expense", "return"].includes(transaction.transaction_type);
  const textColorClass = isNegative 
    ? "text-red-600" 
    : transaction.is_fully_paid === false 
      ? "text-yellow-600" 
      : "text-green-600";

  return (
    <div className="flex items-center gap-2">
      <span className={`font-medium ${textColorClass}`}>
        {isNegative ? "-" : ""}
        {amount.toLocaleString()} FCFA
      </span>
      {transaction.promotion_id && transaction.original_price && (
        <Badge className="bg-green-500">
          -{(((transaction.original_price - (transaction.total_amount / transaction.quantity)) / transaction.original_price) * 100).toFixed(0)}%
        </Badge>
      )}
    </div>
  );
};